
import { Component, Prop, Vue } from "vue-property-decorator";
import { OutOrderRecordDTO, StockInOrderServiceProxy,StockOutOrderServiceProxy} from '@/service-proxies/app-v2/wms.service-proxies'
import { WarehouseAreaServiceProxy,PageStockStatisticsDTO, WarehouseMaterialStockServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies';
import InReportTable from './InReportTable'
import ExportReportTable from './ExportReportTable'
import { exportInOut } from '@/api/api';
const siosp = new StockInOrderServiceProxy()
const msssp = new WarehouseMaterialStockServiceProxy()
const soosp = new StockOutOrderServiceProxy()
const warehouseAreaServiceProxy = new WarehouseAreaServiceProxy()

@Component({
  components: {
    InReportTable,
    ExportReportTable
  }
})
export default class InventoryStatistics extends Vue {  
get columns() {
  return [
    {
      title: this.$t('page_business_material_type'),
      dataIndex: 'materialType',
      ellipsis: true,
      key: 'materialType',
      width: 150,
    },
    {
      title: this.$t('page_business_material_code'),
      dataIndex: 'materialCode',
      ellipsis: true,
      key: 'materialCode',
      width: 150,
    },
    {
      title: this.$t('page_business_material_name'),
      dataIndex: 'materialName',
      ellipsis: true,
      key: 'materialName',
      width: 150,
    },
    {
      title: this.$t('page_control_standardModel'),
      dataIndex: 'standardModel',
      ellipsis: true,
      key: 'standardModel',
      width: 150,
    },
    {
      title: this.$t('page_business_material_property'),
      dataIndex: 'property',
      ellipsis: true,
      key: 'property',
      width: 150
    },
    {
      title: this.$t('page_material_warehousing_unit'),
      dataIndex: 'unit',
      ellipsis: true,
      key: 'unit',
      width: 150,
    },
    {
      title: this.$t('page_material_warehousing_area'),
      dataIndex: 'areaName',
      ellipsis: true,
      key: 'areaName',
      width: 150,
    },
    {
      title: this.$t('page_material_warehousing_location'),
      dataIndex: 'locationName',
      ellipsis: true,
      key: 'locationName',
      width: 150,
    },
    {
      title: this.$t('page_material_ware_out_stockNum'),
      dataIndex: 'locationNum',
      ellipsis: true,
      key: 'locationNum',
      width: 150,
    }
  ]
};

  @Prop({ default: () => [] }) readonly employeesList: any;
  data = []
  height = 300
  selectedRowKey = ""
  pagination = {
    current: 1,
    size: 30
  }
  total = 0
  exportPagination = {
    current: 1,
    size: 30
  }
  exportTotal = 0
  inPagination = {
    current: 1,
    size: 30
  }
  inTotal = 0
  searchKey = ""
  areaId = ""
  showType = "export"
  loading = false
  exportData = []
  inData = []
  selectRecord:any = {}
  exinLoading = false
  idsArr = []
  selectId = ''

  updated(){
    const div = document.body.clientHeight
    this.height = (div - 370) / 2
  }

  mounted(){
    this.getIds()
  }

  async getIds() {
    const res = await warehouseAreaServiceProxy.listWarehouseArea('')
    this.idsArr = res;
    this.selectId = res[0].id
    this.areaId = res[0].id
    this.getList()
  }

  changeId(val) {
    this.areaId = val
    this.getList()
  }

  getList(){
    this.loading = true
    this.data = []
    // this.areaId = this.$route.query.materialId ? (this.$route.query.materialId).toString() : ""
    const seach = {
      areaId: this.areaId,
      keyWord: this.searchKey,
      query: this.pagination
    } as PageStockStatisticsDTO
    msssp.getStockStatistics(seach).then(res =>{
      this.loading = false
      if(Number(res.total) > 0) {
        this.data = this.addKey(res.records)
        this.total = Number(res.total)
        if(this.selectedRowKey === ""){
          this.selectedRowKey = this.data[0].key
          this.selectRecord = this.data[0]
          console.log(this.selectedRowKey)
        }
        if(this.showType === "export"){
          this.exportPagination.current = 1
          this.getExportList()
        } else {
          this.inPagination.current = 1
          this.getInList()
        }
      }
      else {
        this.exportData = []
        this.exportTotal =0;
        this.exportPagination.current = 1
        this.inData = []
        this.inTotal = 0;
        this.inPagination.current = 1;
      }
    }).catch(() =>{
      this.loading = false
    })
  }

  addKey(records){
    if(records && records.length > 0){
      records.forEach((element,index) => {
        element.key = index
      });
    }
    return records
  }

  onSearch(value){
    this.pagination.current = 1
    this.searchKey = value
    this.getList()
  }

  handleExport(){
    exportInOut(this.areaId,this.selectRecord.locationId,this.selectRecord.materialId).then(res =>{
      // 创建隐藏的可下载链接
      var a = document.createElement('a')
      a.download = `${this.$t('page_meterial_inventory_tatistics')}.xlsx`
      a.style.display = 'none'
      // 字符内容转变成blob地址
      // var blob = new Blob([res])
      let url = URL.createObjectURL(res)
      a.href = url
      // 触发点击
      document.body.appendChild(a)
      a.click()
      // 然后移除
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
  }

  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  handleTableChange(current: number, pageSize: number) {
    this.pagination.size = pageSize
    this.pagination.current = current
    this.selectedRowKey = ""
    this.selectRecord = {}
    this.getList()
  }

  clickRow(record){
    this.selectedRowKey = record.key
    this.selectRecord = record
    this.exportPagination.current = 1
    this.inPagination.current = 1
    if(this.showType === "export"){
      this.getExportList()
    } else {
      this.getInList()
    }
  }

  handleShowTypeChange(value) {
    this.showType = value
    this.inData = []
    this.exportData = []
    this.exinLoading = true
    this.exportPagination.current = 1
    this.inPagination.current = 1
    if(value === "export"){
      console.log('选择1')
      this.getExportList()
    } else {
      console.log('选择2')
      this.getInList()
    }
  }

  exportChange(current: number, pageSize: number) {
    this.exportPagination.size = pageSize
    this.exportPagination.current = current
    this.getExportList()
  }

  inChange(current: number, pageSize: number) {
    this.inPagination.size = pageSize
    this.inPagination.current = current
    this.getInList()
  }

  getInList(){
    siosp.getInOrderRecord(this.areaId,this.selectRecord.locationId,this.selectRecord.materialId,this.inPagination.current,this.inPagination.size).then(res =>{
      this.inData = res.records
      this.inTotal = Number(res.total)
      this.exinLoading = false
    })
  }

  getExportList(){
    const value = {
      areaId: this.areaId,
      locationId: this.selectRecord.locationId,
      materialId: this.selectRecord.materialId,
      query: this.exportPagination
    } as OutOrderRecordDTO
    soosp.pageStockOutOrderRecord(value).then(res =>{
      this.exportData = res.records
      this.exportTotal = Number(res.total)
      this.exinLoading = false
    })
  }

  exportReport(){
    return (
      <export-report-table
        loading={this.exinLoading}
        employeesList={this.employeesList}
        pagination={this.exportPagination}
        data={this.exportData}
        height={this.height}
        total={this.exportTotal}
        onHandleTableChange={(current,size) => this.exportChange(current,size)}
      ></export-report-table>
    )
  }
    
  inReport(){
    return (
      <in-report-table
        loading={this.exinLoading}
        employeesList={this.employeesList}
        pagination={this.inPagination}
        data={this.inData}
        height={this.height}
        total={this.inTotal}
        onHandleTableChange={(current,size) => this.inChange(current,size)}
      ></in-report-table>
    )
  }

  render() {
    return (
      <blank-view mainStyle={{ 'background': "transparent", 'box-shadow': "none"}}>
        <div slot={'action'} style="padding-top: 8px;display:flex;justify-content: space-between">
          <div>
            <a-button type="primary" style="margin-right: 8px;" onClick={() => this.handleExport()}>{ this.$t('page_product_export') }</a-button>

            <a-select v-model={this.selectId} optionFilterProp="children" style="width: 140px; font-size: 13px;" onChange={this.changeId}>
            {this.idsArr.map((item) => {
              return (
                <a-select-option key={item.id} value={item.id}>
                  {item.name}
                </a-select-option>
              );
            })}
            </a-select>

            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_product_printing') }</a-button> */}
          </div>
          <div>
            {/* <a-button type="default" style="margin-right: 8px;">{ this.$t('page_my_document_advanced') }</a-button> */}
            <a-input-search placeholder={this.$t('keyword')} style="width: 200px" enterButton={this.$t('search')} onSearch={value => this.onSearch(value)} />
          </div>
        </div>
        <div id="inner" style="height:calc(100% - 40px)">
          <div style="height:50%;position: relative;">
            <ml-table
              loading={this.loading}
              pagination={false}
              columns={this.columns}
              dataSource={this.data}
              bordered
              rowKey="key"
              selectRowKey={this.selectedRowKey}
              scroll={{ y: this.height, x: 2350 }}
              customRow={(record) => {
                return {
                  on: { // 事件
                    click: () => this.clickRow(record),       // 点击行
                  },
                };
              }}
            >
            </ml-table>
            <a-pagination
              style="position:absolute;bottom: 4px;right: 20px"
              show-total={total => `${ this.showTotal(total) }`}
              current={this.pagination.current}
              total={this.total}
              pageSize={this.pagination.size}
              on-change={this.handleTableChange}
              on-showSizeChange={this.handleTableChange}
            />
          </div>
          <div style="height:calc(50% - 8px);margin-top: 8px;">
            <div style="margin-bottom: 8px;width: 100%">
              <a-radio-group value={this.showType} onChange={data => this.handleShowTypeChange(data.target.value)}>
                <a-radio-button value="export">
                  {this.$t('page_outbound_record')}
                </a-radio-button>
                <a-radio-button value="in">
                {this.$t('page_warehousing_record')}
                </a-radio-button>
              </a-radio-group>
            </div>
            {this.showType === "export" ? this.exportReport() : this.inReport()}
          </div>
        </div>
      </blank-view>
    )
  }
}